
import React from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';

interface RawResponseDisplayProps {
  title: string;
  data: Record<string, unknown> | unknown[] | null;
  maxHeight?: string;
}

export const RawResponseDisplay: React.FC<RawResponseDisplayProps> = ({ title, data, maxHeight = "max-h-96" }) => {
  if (!data) return null;

  return (
    <div>
      <h3 className="text-lg font-medium mb-2 mt-6">{title}</h3>
      <ScrollArea className={`${maxHeight} pr-1`}>
        <pre className="text-xs bg-muted p-3 rounded-md overflow-auto">
          {JSON.stringify(data, null, 2)}
        </pre>
      </ScrollArea>
    </div>
  );
};
